import BookListTable from '../components/book_list_table.vue'

export default {
  components: {
    BookListTable
  },
  data: () => ({
  })
}